/** @format */

import * as React from "react";
import { Flex, Image, Text } from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import theme from "@src/style/theme";
import colors from "@src/style/colors";
import DOMPurify from "dompurify";

export const About_Value_KR: React.FC = () => {
  const sanitizer = DOMPurify.sanitize;
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };
  return (
    <Flex
      position={"static"}
      width={"100%"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      backgroundColor={colors.newGray}
      paddingX={basePaddingX}
      paddingY={basePaddingY}
    >
      <Flex
        width="100%"
        maxWidth={theme.breakpoints.mx}
        position={"static"}
        direction={"column"}
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
      >
        <Text
          wordBreak={"keep-all"}
          fontSize={{
            base: "24px",
            sm: "32px",
            md: "35px",
            lg: "52px"
          }}
          mb={{
            base: "50px",
            sm: "70px",
            md: "80px",
            lg: "100px"
          }}
          fontWeight={"700"}
        >
          {commonInfo.about_value.title}
        </Text>
        <Flex
          flexDirection={{ base: "column", md: "row" }}
          justifyContent={"center"}
          alignItems={"flex-start"}
          gap={{ base: "50px", md: "20px" }}
        >
          {commonInfo.about_value.items.map((item, index) => (
            <Flex
              key={index}
              flexDirection={"column"}
              alignItems={"center"}
              textAlign={"center"}
              gap={"20px"}
              flexBasis={"calc(100%/3 - 20px)"}
            >
              <Image
                objectFit={"contain"}
                boxSize={{
                  base: "120px",
                  sm: "160px",
                  md: "100px",
                  lg: "120px"
                }}
                src={item.img}
              />
              <Text
                wordBreak={"keep-all"}
                fontSize={{
                  base: "20px",
                  sm: "24px",
                  md: "20px",
                  lg: "22px"
                }}
                fontWeight={"700"}
              >
                {item.title}
              </Text>
              <Text
                wordBreak={"keep-all"}
                fontSize={{
                  base: "14px",
                  sm: "18px",
                  md: "17px",
                  lg: "22px"
                }}
                fontWeight={"400"}
              >
                {item.description}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default About_Value_KR;
